import { render } from "./BlockWrapperAbout.vue?vue&type=template&id=d2c36b76&scoped=true"
import script from "./BlockWrapperAbout.vue?vue&type=script&lang=js"
export * from "./BlockWrapperAbout.vue?vue&type=script&lang=js"

import "./BlockWrapperAbout.vue?vue&type=style&index=0&id=d2c36b76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2c36b76"]])

export default __exports__